<select [(ngModel)]="selectedRating" class="form-control" name="rating-pulldown" (change)="onChangeSelectedValue($event)" [disabled]="!enabled" data-element-id="app-content-components-container-ratings-pulldown">
    <option *ngFor="let ctype of ratingsList" [value]="ctype.code">{{ctype.code}}</option>
</select>

